import { URLS } from "@constants/urls";
import api from "@helpers/api";

const apiEndPointBaseURL = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.ATTENDANCE}`;

export const updateAttendance = (() => {
  return async ({
    attendanceId,
    data: updatedData,
  }: any): Promise<{ data: any }> => {
    const { employeeId, attendanceDate, statusId } = updatedData;

    return api
      .post(`${apiEndPointBaseURL}`, {
        employeeId,
        attendanceDate,
        statusId,
      })

      .then((response) => {
        return { data: response.data };
      });
  };
})();
